import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAdminContext from "../../store/contexts/AdminContext";
import { ADMIN_ROUTES } from "./AdminPaths";

/**
 * Protected Route Component
 * Only allows authenticated admins to access the route
 */
const AdminProtectedRoute = ({ component: Component, ...rest }) => {
  const { authState } = useAdminContext();
  const { accessToken } = authState;

  return (
    <Route
      {...rest}
      render={(props) =>
        accessToken ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ADMIN_ROUTES.login,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

/**
 * Guest Route Component
 * Only allows non-authenticated users to access the route
 * Redirects authenticated users to dashboard
 */
const AdminGuestRoute = ({ component: Component, ...rest }) => {
  const { authState } = useAdminContext();
  const { accessToken } = authState;

  return (
    <Route
      {...rest}
      render={(props) =>
        !accessToken ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: ADMIN_ROUTES.dashboard,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};

export { AdminProtectedRoute, AdminGuestRoute };
